import styles from "./styles.module.scss"
import { SystemMessage } from "../SystemMessage"
import {
  NavigatorMessage,
  NavigatorSystemNotificationData,
  NavigatorUserMessage,
  TripRoomID,
  UserID,
} from "@cruisen/contract"
import { UserMessage } from "../UserMessage"
import { timestampToDate } from "@cruisen/react-shared"

export const MessageRenderer = ({
  message,
  showAvatarAndName,
  showMessageDate,
  currentUserRoomId,
  currentUserRoomName,
  currentUserId,
  tripOwnerId,
}: {
  message: NavigatorMessage
  showAvatarAndName: boolean
  showMessageDate: boolean
  currentUserRoomId: TripRoomID
  currentUserRoomName: string
  currentUserId: UserID
  tripOwnerId: UserID
}) => {
  return (
    <>
      {showMessageDate && (
        <p className={styles.messageDate}>{timestampToDate(message.timestamp)}</p>
      )}

      <div>
        {(message.source === "system" || message.source === "bot") && (
          <SystemMessage
            message={message.message}
            messageData={
              { type: message.type, data: message.data } as NavigatorSystemNotificationData
            }
            showAvatarAndName={showAvatarAndName}
            currentUserRoomId={currentUserRoomId}
            currentUserRoomName={currentUserRoomName}
            currentUserId={currentUserId}
            tripOwnerId={tripOwnerId}
            timeStamp={message.timestamp}
          />
        )}
        {(message.source === "user" || message.source === "support") && (
          <UserMessage
            message={message.message}
            showAvatarAndName={showAvatarAndName}
            authorDetails={{
              isSupport: message.source === "support",
              userId: message.userId,
              firstName: message.userFirstName,
              lastName: message.userLastName,
              avatar: message.userAvatar,
            }}
            timeStamp={message.timestamp}
            fileData={(message as NavigatorUserMessage)?.file || null}
          />
        )}
      </div>
    </>
  )
}
